import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

Sentry.init({
    dsn: "https://1da0d5580155ab0a7df6cb5e8d4ffdcd@o405532.ingest.us.sentry.io/4511070848811008",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true
})

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
